import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
//import { openModal } from "../../actions/Modal";
//import { setHistory, redirect } from "../../actions/App";
//import { ThemeContext } from "../../configurations/Theme";
// import Dashboard from "../../containers/Dashboard";
import CoverImage from "../../components/coverImage";
import PlantInformation from "../../components/EmployeCard/plantinformation";
import SideMenu from "../../components/sideMenu";
import Welcome from "../../containers/welcome";
import EmployeContainer from "../../containers/Employe";
import Dashboard from "../../containers/Dashboard";
import Creditors from "../../containers/Creditors";
import { UserAction } from "../../store/actions";
import AccountSetting from "../../containers/AccountSetting";
import CatalogContainer from "../../containers/Catalog/catalog";
import OrderDetail from "../../containers/OrderDetail";
import CatalogNew from "../../containers/CatalogNew";
import ContractorsContainer from "../../containers/Contractors";
import PlantContainer from "../../containers/Plant/index";
import LogisticsContainer from "../../containers/Logistics/index";
import ProductUpdate from "../../containers/ProductUpdate";
import Basemix_Info from "../../containers/BasemixUpdate";
import Additive_Info from "../../containers/AdditivesUpdate";
import Category_Info from "../../containers/CategoriesUpdate";
import General_Info from "../../components/generalInfo";
import AccountDashboard from "../../containers/Settings";
import CompaniesDetails from "../../containers/Plant/companiesDetails";
import logisticsDetails from "../../containers/Plant/logisticsDetails";
import LogisticsOrderDetail from "../../containers/OrderDetail/logisticsOrderDetails";
class AuthRoutes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsedRight: true,
      collapsedLeft: false,
      ScreenWidth: window.innerWidth,
    };

    this.handleWidthChange = this.handleWidthChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      //this.props.redirect(this.props.location.pathname);
    }
    window.addEventListener("resize", this.handleWidthChange);
  }

  componentDidMount() {
    //this.props.setHistory(this.props.history);
    //this.props.redirect(this.props.location.pathname);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWidthChange);
  }
  handleWidthChange = () => {
    this.setState({
      ScreenWidth: window.innerWidth,
    });
  };
  toggleCollapsed = (type) => {
    this.setState({
      [type]: !this.state[type],
    });
  };

  render() {
    if (this.props.location.pathname === "/reauth") {
      //
      this.props.createLink();
    }
    if (this.props.location.pathname === "/checkaccount") {
      this.props.checkAccount({ flag: this.props.location.search });
    }
    return (
      <Switch>
        <SideMenu>
          <Route exact path="/dashboard" component={Dashboard} />
          <Route exact path="/contractors" component={ContractorsContainer} />
          <Route exact path="/rmx" component={PlantContainer} />
          <Route exact path="/rmx/:id/orders" component={CompaniesDetails} />
          <Route
            exact
            path="/rmx/:id/orders/:orderid"
            component={OrderDetail}
          />

          <Route exact path="/logistics" component={LogisticsContainer} />
          <Route
            exact
            path="/logistics/:id/orders"
            component={logisticsDetails}
          />
          <Route
            exact
            path="/logistics/:id/orders/:orderid"
            component={LogisticsOrderDetail}
          />
          <Route exact path="/employees" component={EmployeContainer} />
          <Route exact path="/creditors" component={Creditors} />
          <Route exact path="/product" component={CatalogContainer} />
          <Route exact path="/account" component={AccountDashboard} />
          <Route path="/product/new" component={General_Info} />
          <Route path="/product/:id/update" component={General_Info} />
          <Route path="/basemix/new" component={Basemix_Info} />
          <Route path="/basemix/:id/update" component={Basemix_Info} />
          <Route path="/additives/new" component={Additive_Info} />
          <Route path="/additives/:id/update" component={Additive_Info} />
          <Route path="/categories/new" component={Category_Info} />
          <Route path="/categories/:id/update" component={Category_Info} />

          {/* <Route exact path="/accounts" component={AccountSetting} />

          {/* <Route exact path="*" render={() => <Redirect to="/accounts" />} /> */}
        </SideMenu>
      </Switch>
    );
  }
}

//Shell.contextType = ThemeContext;

export default connect(
  (state) => ({ storeState: state }),
  (dispatch) => ({
    createLink: () => dispatch(UserAction.createLinkReq()),
    checkAccount: (data) => dispatch(UserAction.checkAccountReq(data)),
  })
)(AuthRoutes);
